import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PendingGlyph } from "../glyphs.js";
/**
 * The signed-out card (console redesign screen-catalog S1; epic 26-10-27-person-files-voice
 * design-spec §4.1.1): a 440-wide card on `--sheet`, 180 from the top, padding 40 40 34, gap
 * 22, centered text, the wordmark at 34/700. Two users: the owner's sign-in screen and the
 * Connections page's opening, link-expired and timed-out cards.
 */
export function SignedOutCard({ wordmark, title, status, children, hook, cardHook }) {
    return (_jsx("div", { ...(hook ? { [hook]: "" } : {}), "data-signed-out": "", style: {
            flex: 1, minHeight: 0, overflow: "auto",
            display: "flex", justifyContent: "center", alignItems: "flex-start",
            padding: "180px var(--space-2) var(--space-5)",
        }, children: _jsxs("div", { ...(cardHook ? { [cardHook]: "" } : {}), "data-signed-out-card": "", style: {
                boxSizing: "border-box", width: 440, maxWidth: "100%",
                background: "var(--sheet)", boxShadow: "var(--sheet-edge)", borderRadius: "var(--radius-sheet)",
                padding: "var(--space-5) var(--space-5) 34px",
                display: "flex", flexDirection: "column", alignItems: "center", gap: 22, textAlign: "center",
            }, children: [_jsx("div", { style: {
                        color: "var(--ink-1)", fontSize: "var(--type-wordmark-size-signin)",
                        fontWeight: "var(--type-wordmark-weight)", letterSpacing: "var(--type-wordmark-tracking-signin)",
                        lineHeight: "var(--type-display-line)",
                    }, children: wordmark }), title !== undefined && (_jsx("h1", { style: {
                        margin: 0, color: "var(--ink-1)", fontSize: "var(--type-title-size)",
                        lineHeight: "var(--type-title-line)", fontWeight: "var(--type-title-weight)",
                        letterSpacing: "var(--type-title-tracking)",
                    }, children: title })), status !== undefined && (_jsxs("div", { role: "status", "data-signed-out-status": "", style: {
                        display: "flex", alignItems: "center", gap: "var(--space-1)", color: "var(--ink-2)",
                        fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
                    }, children: [_jsx(PendingGlyph, {}), _jsx("span", { children: status })] })), children] }) }));
}
